import React from "react";
import { UserLoggedInNavigatorParamList } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { HeaderButton } from "../../../../components";

import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { Header } from "@react-navigation/elements";
import { Box, useTheme } from "arkh";

export function WAFakeHeader({
  headerLeftType = "CANCEL",
  title = "",
}: {
  title?: string;
  headerLeftType?: Parameters<typeof HeaderButton>[0]["type"] | null;
}) {
  const navigation =
    useNavigation<NativeStackNavigationProp<UserLoggedInNavigatorParamList>>();
  const theme = useTheme();

  return (
    <Header
      title={title}
      headerStyle={{
        backgroundColor: theme.surface,
      }}
      modal={true}
      headerStatusBarHeight={0}
      headerTitleAlign="center"
      headerLeft={
        headerLeftType !== null
          ? () => (
              <Box spaceLeft="small">
                <HeaderButton
                  type={headerLeftType}
                  onPress={navigation.goBack}
                />
              </Box>
            )
          : undefined
      }
    />
  );
}
